import { FullDealCalculatorWithAuthSheet } from 'features/FullDeal/ui/FullDealCalculatorWithAuthSheet/FullDealCalculatorWithAuthSheet';
import { FullDealCalculatorBottomSheet } from 'widgets/FullDealEntryPoint';
import { modalService } from 'widgets/GlobalDialog';
import type { CardProps } from 'widgets/LightweightCard/lib/types';

export const sravniOfferAction = {
  condition: (options: CardProps) => options.isMobile && options.offer?._features?.isSravniOffer,
  action: async (event, props: CardProps) => {
    modalService.open({
      component: FullDealCalculatorBottomSheet,
      props,
    });
    event.preventDefault();
    event.stopPropagation();
  },
};

export const fullDealOfferAction = {
  condition: (options: CardProps) => options.offer?._features?.isFullDealOffer,
  action: async (event, props: CardProps) => {
    modalService.open({
      component: FullDealCalculatorWithAuthSheet,
      props,
    });
    event.preventDefault();
    event.stopPropagation();
  },
};
